import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';

import {LoginRoutingModule} from './login-routing.module';
import {LoginComponent} from './login.component';
import {FirstTimeLoginComponent} from './first-time-login/first-time-login.component';
import {ForgotPasswordComponent} from './forgot-password/forgot-password.component';
import {CommonTudComponentsModule} from '../common/common-tud-components.module';
import {ReactiveFormsModule} from '@angular/forms';
import {TranslateModule} from '@ngx-translate/core';
import {MatStepperModule} from '@angular/material/stepper';
import {FontAwesomeModule} from '@fortawesome/angular-fontawesome';
import {AdminModule} from '../admin/admin.module';
import {MfaModule} from '../mfa/mfa.module';
import {NgbTooltipModule} from '@ng-bootstrap/ng-bootstrap';

@NgModule({
    imports: [
        //TUD Modules
        LoginRoutingModule,
        CommonTudComponentsModule,
        AdminModule,
        MfaModule,
        //Dependencies
        CommonModule,
        TranslateModule.forChild(),
        ReactiveFormsModule,
        MatStepperModule,
        FontAwesomeModule,
        NgbTooltipModule,
        LoginComponent,
        FirstTimeLoginComponent,
        ForgotPasswordComponent
    ]
})
export class LoginModule {}
